<template>

<b-card no-body>
        <!-- Card header -->
        <b-card-header>
            <!-- Title -->
            <h5 class="h3 mb-0">My Art Books</h5>
        </b-card-header>
        <!-- Card search -->
        <b-card-header class="py-0" v-if="showSearch">
            <!-- Search form -->
            <b-form>
                <b-form-group class="mb-0">
                    <base-input class="input-group-lg input-group-flush mb-0"
                                prepend-icon="fas fa-search"
                                placeholder="Search"
                                type="search"
                                v-model="membersSearch">
                    </base-input>
                </b-form-group>
            </b-form>
        </b-card-header>
        <!-- Card body -->
        <b-card-body>

          <div class="loader" v-if="loading"></div>

            <!-- List group -->
            <b-list-group flush class="list my--3">
                <b-list-group-item v-for="book in booksList"
                    :key="book.photo_book.id"
                    class="list-group-item px-0">
                    <b-row align-v="center" >
                        <b-col md="auto">
                            <!-- Avatar -->
                            <a href="#" class="avatar">
                                <b-img v-if="book.photo_book.thumb"
                                       alt="Book thumbnail"
                                       :src="book.photo_book.thumb" />
                                <b-img v-else
                                       alt="No image placeholder"
                                       src="/img/icons/common/icon-img-box.svg" />
                            </a>
                        </b-col>
                        <b-col class="ml--2">
                            <h4 class="mb-0">
                                <a href="#!">{{ book.photo_book.title }} <small>{{ book.photo_book.subtitle }}</small></a>
                            </h4>
                            <span :class="`text-${book.photo_book.state}`">● </span>
                            <small>{{ book.photo_book.written_next_step }}</small>
                        </b-col>
                        <b-col md="auto">
                          <a :href="'#/artist/'+book.photo_book.id+'/wizard'" class="btn btn-sm btn-dark">Show</a>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </b-list-group>
        </b-card-body>
    </b-card>
    
  
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from 'moment'
  
  export default {
    name: "my-photo-books",
    data() {
      return {
        loading: false,
        booksList: [],
        membersSearch: '',
        showSearch: false,
      };
    },
    methods: {
      retrieveBooks() {
        this.loading = true;
        this.$api.getPhotoBooks("")
          .then((response) => {
            console.log(response);
            this.booksList = response.data.photo_books;
            console.log(this.booksList);
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
      },
      formatDate(date) {
        return moment(date).format("Do MMM YYYY")
      },
    },
    computed: {
      ...mapGetters({ currentAccount: 'currentAccount' }),
      booksLoaded: function(){
          return this.booksList ? true : false;
      }
    },
  
    mounted() {
      this.retrieveBooks();
    },
  };
  </script>
  <style>
  </style>